var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M6 21c-.75 0-1.492-.183-2.225-.55C3.042 20.083 2.45 19.6 2 19c.433 0 .875-.17 1.325-.512C3.775 18.146 4 17.65 4 17c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 7 14c.833 0 1.542.292 2.125.875S10 16.167 10 17c0 1.1-.392 2.042-1.175 2.825C8.042 20.608 7.1 21 6 21zm5.75-6L9 12.25l8.95-8.95a.977.977 0 0 1 .688-.287.93.93 0 0 1 .712.287l1.35 1.35c.2.2.3.433.3.7 0 .267-.1.5-.3.7L11.75 15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M6 19c.55 0 1.02-.196 1.412-.587C7.804 18.02 8 17.55 8 17a.968.968 0 0 0-.287-.712A.968.968 0 0 0 7 16a.968.968 0 0 0-.713.288A.968.968 0 0 0 6 17c0 .383-.046.733-.138 1.05a4.727 4.727 0 0 1-.362.9c.083.033.167.05.25.05H6z"
}))));
export default SvgFormatIcon;